import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterConfig, ToasterService } from 'angular2-toaster';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Nexus_Fynd';

  public config: ToasterConfig = new ToasterConfig( {showCloseButton: true, timeout:5000});

  constructor(private Config: ConfigService, public http: HttpClient, public toasterService:ToasterService, private activeRoute: ActivatedRoute, private router:Router){
  //   this.http.get('assets/config.json').subscribe((res:any) => {
      
  //     localStorage.setItem("url", res.baseURL);
  //     localStorage.setItem("cdnURL", res.cdnURL);
  //     localStorage.setItem("appCode", res.appCode);
  //     localStorage.setItem("projectURL", res.projectURL);
  //     // localStorage.setItem('_tid', '_' + res.tenantId);
  //     // localStorage.setItem("registerId", res.userId);
  //     // localStorage.setItem("accessToken", res.access_token);
  //     console.log(res)
  //     this.Config.getLocalStorageData();
  // });

  
  }   
}
